import Stack from '@mui/material/Stack'
import React, { useEffect, useState } from 'react'
import { AdvisorSelect } from '../../components/AdvisorSelect'
import { AdvisorEntity } from 'types/AdvisorEntity'
import AdvisorApi from '../../api/AdvisorApi'
import { WatchListItem } from 'types/WatchListEntity'

const advisorApi = new AdvisorApi()

export const AddAvisorWatchItem = ({
    onAdd,
    typeLowercase,
}: {
    onAdd: (advisor: Pick<WatchListItem, 'name' | 'id'>) => void
    typeLowercase: string
}) => {
    const [advisors, setAdvisors] = useState<AdvisorEntity[] | null>(null)

    useEffect(() => {
        void (async () => {
            const result = await advisorApi.findAll()

            setAdvisors(result)
        })()
    }, [])

    const handleSelect = (advisor: AdvisorEntity) => {
        console.log({ advisor })
        onAdd({ id: advisor.id, name: advisor.name })
    }

    return (
        <>
            <p style={{ fontWeight: 'bold' }}>Lägg till {typeLowercase} i bevakningslista</p>
            <Stack direction='row' sx={{ maxWidth: 400 }}>
                {advisors && <AdvisorSelect advisors={advisors} label='Sök rådgivare' onSelect={handleSelect} />}
            </Stack>
        </>
    )
}
